import useMediaQueryHooks from 'hooks/useMediaQueryHooks'
import Constant from 'utils/Constants'

const useIsMobileHooks = (width = Constant.mediaQuery.isMobile) => {
    const isMobile = useMediaQueryHooks(width)
    return isMobile
}

export default useIsMobileHooks